var map = {
	"./404.svg": 457,
	"./bug.svg": 458,
	"./chart.svg": 459,
	"./clipboard.svg": 460,
	"./component.svg": 461,
	"./dashboard.svg": 462,
	"./documentation.svg": 463,
	"./drag.svg": 464,
	"./edit.svg": 465,
	"./email.svg": 466,
	"./example.svg": 467,
	"./excel.svg": 468,
	"./eye.svg": 469,
	"./form.svg": 470,
	"./guide 2.svg": 471,
	"./guide.svg": 472,
	"./icon.svg": 473,
	"./international.svg": 474,
	"./language.svg": 475,
	"./link.svg": 476,
	"./list.svg": 477,
	"./lock.svg": 478,
	"./message.svg": 479,
	"./money.svg": 480,
	"./nested.svg": 481,
	"./password.svg": 482,
	"./people.svg": 483,
	"./peoples.svg": 484,
	"./qq.svg": 485,
	"./shopping.svg": 486,
	"./size.svg": 487,
	"./star.svg": 488,
	"./tab.svg": 489,
	"./table.svg": 490,
	"./theme.svg": 491,
	"./tree.svg": 492,
	"./user.svg": 493,
	"./wechat.svg": 494,
	"./zip.svg": 495
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 456
// module chunks = 75